export class RollUp {
    public team: string;
    public teamYear: string;
    public year = new Date().getUTCFullYear();
    public updatedAt = new Date().getTime();
}
